export const EmbedType = {
    OBSERVATION: 'Observation',
    MARKDOWN: 'markdown',
    INVOICE: 'Daycare.Invoice',
    VACATION: 'Daycare.Vacation',
    EVENT: 'Daycare.Event',
    NPS: 'nps',
    FAMLY_PAY_SETUP: 'FamlyPay.Setup',
    ACTIVITIES: 'activities',
};
